$(function(){
    if(!$(".gameboard-gametable-results").length)
        return;

    var $wrp=$(".gameboard-gametable-results");
    var $ed=$(".gameboard-gametable-results .edit-button button.edit");
    var $edB=$(".gameboard-gametable-results .edit-button");
    var $savB=$(".gameboard-gametable-results .date-buttons");
    var $save=$(".gameboard-gametable-results .date-buttons button.save");
    var $cancel=$(".gameboard-gametable-results .date-buttons button.cancel");

    $savB.hide();

    $ed.on("click",function(){
        $wrp.find("input").removeClass("disabled").prop("disabled",false);
        $savB.show();
        $edB.hide();
        return false;
    });

    $save.on("click",function(){

        
        //post
        var send={};
        $wrp.find("input").each(function(i,item){
            if(typeof $(item).attr("data-team")==='undefined')
                return;
            if(typeof send[$(item).attr("data-team")]==='undefined')
                send[$(item).attr("data-team")]={};
            send[$(item).attr("data-team")][$(item).attr("data-type")]=$(item).val();
        });
        console.log(send);
        $wrp.find("input").addClass("disabled").prop("disabled",true);
        $savB.hide();
        $edB.show();
        $.post("/gameboard/table/save",{results:send},function(resp){
            //reload
            $('[table-magick]').each(function(i,el){
                el.magick.reload();
            });
        });
        return false;
    });

    $cancel.on("click",function(){
        $wrp.find("input").each(function(){
            $(this).addClass("disabled").prop("disabled",true).val($(this).attr("data-def"));
        });
        $savB.hide();
        $edB.show();
    });
});